<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col>
                <div class="pa-2 rounded elevation-1 bg-white">
                    <div>
                        <SportipsButton @onClick="goBack" chevronLeft>Retour</SportipsButton>
                    </div>
                    <div class="text-h5 font-weight-bold my-2">Modifier le groupe</div>
                    <div>Modifiez les informations et les limites de ce lien d'inscription de groupe.</div>
                    <LienGroupeInscriptionEditForm class="mt-4"></LienGroupeInscriptionEditForm>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import LienGroupeInscriptionEditForm from "@/components/Administration/LiensGroupeInscription/EditForm.vue";
export default {
    components: { LienGroupeInscriptionEditForm },
    methods: {
        goBack() {
            this.$router.push({
                name: 'LienGroupeInscription',
                params: { base_module: this.$route.params.base_module },
            });
        },
    },
}
</script>

<style lang="scss" scoped></style>
